// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"24738bd2","292":"35d24265","384":"86131842","584":"b58ab8e2","897":"23017e55"}[chunkId] + ".chunk.css";
};